import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_ScrollPanel = _resolveComponent("ScrollPanel")

  return (_openBlock(), _createBlock(_component_ScrollPanel, {
    ref: "panel",
    "pt:root:class": "root",
    "pt:contentcontainer:class": "contentcontainer",
    "pt:content:class": "content",
    "pt:bary:class": "bary",
    "pt:barx:class": "barx",
    class: _normalizeClass({fade: $props.fade})
  }, {
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default", {}, undefined, true)
    ]),
    _: 3 /* FORWARDED */
  }, 8 /* PROPS */, ["class"]))
}